/* eslint-disable no-useless-escape */

import { BehaviorSubject } from "rxjs";
import { handleResponse } from "../_helpers/handle-response";
import { authHeaderWithOutToken } from "../_helpers/auth-header.js";
import { BASE_URL } from "../_constants/services.constants.js";
const currentUserSubject = new BehaviorSubject(
  JSON.parse(localStorage.getItem("currentUser") || "null")
);

export const authenticationService = {
  login,
  logout,
  forgotPassword,
  updateLocalStorage,
  currentUser: currentUserSubject.asObservable(),
  get currentUserValue() {
    if (!currentUserSubject.value) {
      return null;
    }
    return currentUserSubject.value;
  },
};

function login(formData) {
  const requestOptions = {
    method: "POST",
    headers: authHeaderWithOutToken(),
    body: formData,
  };
  return fetch(`${BASE_URL}/Login/LoginUser`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      if (data.isSuccess) {
        const user = {
          id: data.data.id,
          emailId: data.data.emailId,
          firstName: data.data.firstName,
          lastName: data.data.lastName,
          contact: data.data.contact,
          lastLogin: data.data.lastLogin,
          token: data.data.token,
          role: data.data.role,
        };
        localStorage.setItem("currentUser", JSON.stringify(user));
        currentUserSubject.next(user);
        return "";
      } else {
        return data.message;
      }
    });
}
function updateLocalStorage(user) {
  localStorage.setItem("currentUser", JSON.stringify(user));
  currentUserSubject.next(user);
}
function forgotPassword(formData) {
  const requestOptions = {
    method: "POST",
    headers: authHeaderWithOutToken(),
    body: formData,
  };
  return fetch(`${BASE_URL}/Login/ForgetPassword`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data.message;
    });
}

function logout() {
  localStorage.removeItem("currentUser");
  currentUserSubject.next(null);
}

export default authenticationService;
